<template>
  <div class="carousel-item">
    <div class="top">
      <span class="title">{{data.title}}</span>
      <span @click="more(data)"
            class="icon pointer"><i class="iconfont icon-arrow-right"></i></span>
    </div>
    <div v-for="(item,index) in data.content"
         :key="index">
      <div class="content"
           @click="goPage(item,data)"
           v-if="currentIndex == index">
        <el-image :src="$jx.oss(item.img)"
                  style="width: 200px; height: 100px; margin-right: 20px;"
                  fit="cover"></el-image>
        <div class="c">
          <span class="t ellipsis">{{item.title}}</span>
          <div class="n ellipsis-3">
            {{item.describe}}
          </div>
        </div>
      </div>
    </div>

    <div class="p">
      <div @mouseenter="mouseenter($event,index)"
           @mouseleave="mouseleave($event,index)"
           @click="tabClick(index)"
           class="pointer item"
           :class="currentIndex == index ? 'cur': ''"
           v-for="(item,index) in data.content"
           :key="item.id+'-'+index"></div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    data: {
      type: Object
    },
    indexs: {
      type: String | Number
    }
  },
  data () {
    return {
      currentIndex: 0
    }
  },
  methods: {
    t (index) {
      switch (index) {
        case 0:
          return '新品推荐'
          break;
        case 1:
          return '推荐供应商'
          break;
        case 2:
          return '应用与分享'
          break;
        case 4:
          return '最新资讯'
          break;

        default:
          break;
      }
    },
    goPage (item, data) {
      if (data.title == "新品推荐") {
        return this.$router.push({
          path: `/proprietary/newsGoodsInfo/${item.id}`,
        })
      }
      this.$router.push({
        path: `/news/details/${item.id}`,
      })
    },
    more (item) {
      if (item.title == "新品推荐") {
        return this.$router.push({
          path: `/proprietary/newsGoods`,
        })
      }
      this.$router.push({
        path: `/news/list/${this.indexs}`,
      })
    },
    tabClick (index) {
      // if (this.currentIndex != index) {
      this.currentIndex = index
      // }
    },
    mouseenter (e, index) {
      // if (this.currentIndex != index) {
      this.currentIndex = index
      // }
    },
    mouseleave (e, index) {
      // if (this.currentIndex != index) {
      this.currentIndex = index
      // }
    }
  }
}

</script>
<style scoped lang="scss">
.carousel-item {
  background-color: #fff;
  border-radius: 6px;
  padding: 15px;
  box-sizing: border-box;
  white-space: normal;
   .p {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 30px;

    .item {
      width: 15px;
      height: 6px;
      background-color: #cccccc;
      margin: 0 4px;
      border-radius: 4px;
      white-space: normal;
    }

    .cur {
      background-color: #0093e6;
    }
  }

  .content {
    display: flex;
    justify-content: space-between;
    cursor: pointer;
    white-space: normal;
    .c {
      font-size: 14px;
      flex: 1;
      white-space: normal;
      .t {
        color: #000;
        font-weight: bold;
        font-size: 16px;
        display: inline-block;
        white-space: normal;
      }

      .n {
        color: #999;
        margin-top: 20px;
      }
    }

    img {
      width: 200px;
      height: 100px;
      margin-right: 20px;
    }
  }

  .top {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .title {
      color: #000;
      font-size: 18px;
      font-weight: bold;
      margin-bottom: 10px;
    }

    .icon {
      display: inline-block;
      border: 1px solid #999;
      width: 20px;
      height: 20px;
      border-radius: 50%;
      line-height: 20px;
      text-align: center;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/carousel-item/carousel-item.vue